define([
    '../Util/defaultValue',
    '../Util/defined',
    '../Util/encode',
    '../Util/callbackSystem',
    '../System/Vec3Obj',
    './PresentationItem',
    '../Enum/EnumPresentationStatus'
], function (
    defaultValue,
    defined,
    encode,
    callbackSystem,
    Vec3Obj,
    PresentationItem,
    EnumPresentationStatus
) {
    'use strict';

    /**
     * 演示系统对象。
     * 
     * @demo {@link http://lbs.zjkelan.com/Presentation.html|CooWasm Presentation demo}
     * @alias Presentation
     * @constructor
     *
     * @param {Object} props 包含如下属性的Object：
     * @param {Array.<PresentationItem>} [props.items] 演示子项数组。
     * @param {EnumPresentationStatus} [props.status=EnumPresentationStatus.PLAY] 演示系统播放状态。
     * @param {CallbackBoolean} [callback=null] 加载成功后触发的函数回调。
     * @example
     * var presentation = new CooWasm.Presentation({},(state)=>{console.log("load status:" + state)});
     */
    class Presentation {
        /**
         * @description 演示子项数组。
         * @type {Array.<PresentationItem>}
         */
        items;
        /**
         * @description 演示子项uuid数组。
         * @type {Array.<String>}
         * @private
         */
        uuids = [];
        /**
         * @description 演示系统播放状态。
         * @type {EnumPresentationStatus}
         */
        status;
        /**
         * @description 演示系统对象uuid。
         * @type {String}
         * @readonly
         */
        avatarUuid = null;
        /**
         * @description 演示系统组件uuid。
         * @type {String}
         * @readonly
         */
        componentUuid = null;
        /**
         * @description Presentation在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "Presentation";
        static avatarType = "deSMP.Avatar.EmptyAvatar";
        static componentType = "deSMP.AvatarComponent.PresentationComponent";

        constructor(props, callback) {
            if (!defined(props)) {
                return null;
            }
            this.items = props.items;
            this.status = defaultValue(props.status, EnumPresentationStatus.PLAY);
            //create avatars
            var aCategory = encode("deSMP.Avatar");
            var aName = encode("EmptyAvatar");
            var cCategory = encode("deSMP.AvatarComponent");
            var cName = encode("PresentationComponent");

            var idInfo = Element.prototype.NativeAPI.LoadPresentation();
            if (idInfo != "") {
                var idArray = idInfo.split('|');
                this.avatarUuid = idArray[0];
                this.componentUuid = idArray[1];
                callbackSystem.register("LoadAvatarAndComponent", this.avatarUuid, (state) => {
                    if (state) {
                        if (defined(this.items)) {
                            callbackSystem.register("UpdateAvatarAndComponent", this.avatarUuid, (state1) => {
                                let list = Element.prototype.NativeAPI.GetPresentationItem(encode(this.avatarUuid), encode(this.componentUuid), false);
                                console.log("uuids:" + list);
                                Element.prototype.NativeAPI.UpdatePresentation(encode(this.avatarUuid), encode(this.componentUuid), this.status);
                                if (defined(callback)) {
                                    callback(state1);
                                }
                            });
                            let avatarProps = "";
                            let componentProps = "";
                            let str = "[";
                            this.items.forEach(item => {
                                str += item.toStr() + ","
                            })
                            str = str.slice(0, -1) + "]";
                            componentProps += "PresentationItems:" + str + "|";
                            Element.prototype.NativeAPI.UpdateAvatarAndComponent(encode(this.avatarUuid), encode(this.componentUuid), encode(avatarProps), encode(componentProps), true);
                        } else {
                            if (defined(callback)) {
                                callback(state);
                            }
                        }
                    }
                    Element.prototype.Map.presentations.push(this);
                })
                // console.log("Presentation avatarUuid:" + this.avatarUuid + " componentUuid:" + this.componentUuid);
            }
        }

        /**
         * <p>
         * 更新单个或者多个对象属性，使之立即生效。
         * </p>
         *
         * @param {Object} [props] 包含如下属性的Object。
         * @param {Array.<PresentationItem>} [props.items] 演示子项数组。
         * @param {EnumPresentationStatus} [props.status] 演示系统播放状态。
         * @param {CallbackBoolean} [callback=null] 更新成功后触发的函数回调。
         * @example
         * presentation.update({
         *    status:CooWasm.EnumPresentationStatus.PAUSE
         * },(state)=>{console.log("update status:" + state)});
         */
        update(props, callback) {
            let avatarProps = "";
            let componentProps = "";
            if (defined(props)) {
                if (defined(props.items)) {
                    this.items = props.items;
                    let str = "[";
                    this.items.forEach(item => {
                        str += item.toStr() + ","
                    })
                    str = str.slice(0, -1) + "]";
                    componentProps += "PresentationItems:" + str + "|";
                }
                
                callbackSystem.register("UpdateAvatarAndComponent", this.avatarUuid, (state) => {
                    let list = Element.prototype.NativeAPI.GetPresentationItem(encode(this.avatarUuid), encode(this.componentUuid), false);
                    let listArr = list.split(';');
                    if (this.items.length == listArr.length) {
                        for (let i = 0; i < listArr.length; ++i) {
                            this.items[i].uuid = listArr[i];
                            console.log(this.items[i].uuid);
                        }
                    }
                    if (defined(props.status)) {
                        if (props.status == EnumPresentationStatus.PLAY) {
                            this.play();
                        } else if (props.status == EnumPresentationStatus.PAUSE) {
                            this.pause();
                        } else if (props.status == EnumPresentationStatus.STOP) {
                            this.stop();
                        }
                    }
                    this.getProperties();
                    if (defined(callback)) {
                        callback(state);
                    }
                });
                Element.prototype.NativeAPI.UpdateAvatarAndComponent(encode(this.avatarUuid), encode(this.componentUuid), encode(avatarProps), encode(componentProps), true);
            }
        }
        // /**
        //  * 根据类型创建演示子项。
        //  *
        //  * @param {EnumPresentationItemType} type 演示子项类型。
        //  * @param {EnumConditionType} condition 执行动作条件类型。
        //  * @param {Number} time 执行动作等待时间，单位：秒。
        //  * @param {Array.<String>|String} [uuids] 当type为非CAMERA时，需要传入待控制的对象id或者id数组。
        //  */
        // createItem(type, condition, time, uuids) {
        //     let ids = "";
        //     if (Array.isArray(uuids)) {
        //         uuids.forEach(item => {
        //             ids += item + " ";
        //         });
        //     }else{
        //         ids = uuids;
        //     }
        //     Element.prototype.NativeAPI.CreatePresentationItem(encode(this.avatarUuid), encode(this.componentUuid), type, condition, time, encode(ids));
        // }
        /**
         * 播放演示子项。
         * @example
         * presentation.play();
         */
        play() {
            if (!defined(this.avatarUuid)) {
                console.log("uuid require!");
                return false;
            }
            
            callbackSystem.register("", "PresentationItemEnd", (uuid) => {
                console.log(uuid);
                const index = this.items.findIndex(item => item.uuid == uuid);
                if (defined(this.items[index].func)) {
                    this.items[index].func();
                }
            });
            Element.prototype.NativeAPI.UpdatePresentation(encode(this.avatarUuid), encode(this.componentUuid), EnumPresentationStatus.PLAY);
        }
        /**
         * 暂停演示子项。
         * @example
         * presentation.pause();
         */
        pause() {
            if (!defined(this.avatarUuid)) {
                console.log("uuid require!");
                return false;
            }
            Element.prototype.NativeAPI.UpdatePresentation(encode(this.avatarUuid), encode(this.componentUuid), EnumPresentationStatus.PAUSE);
        }
        /**
         * 停止播放演示子项。
         * @example
         * presentation.stop();
         */
        stop() {
            if (!defined(this.avatarUuid)) {
                console.log("uuid require!");
                return false;
            }
            Element.prototype.NativeAPI.UpdatePresentation(encode(this.avatarUuid), encode(this.componentUuid), EnumPresentationStatus.STOP);
        }
        clear() {
            if (!defined(this.avatarUuid)) {
                console.log("uuid require!");
                return false;
            }
            Element.prototype.NativeAPI.UpdatePresentation(encode(this.avatarUuid), encode(this.componentUuid), EnumPresentationStatus.CLEAR);
        }
        /**
         * 继续下一个演示子项。
         * @example
         * presentation.next();
         */
        next() {
            if (!defined(this.avatarUuid)) {
                console.log("uuid require!");
                return false;
            }
            Element.prototype.NativeAPI.GetPresentationItem(encode(this.avatarUuid), encode(this.componentUuid), true);
        }
        locate(callback) {
            callbackSystem.register("", "LocateAvatar", (state) => {
                if (defined(callback)) {
                    callback(state);
                }
            });
            Element.prototype.NativeAPI.LocateAvatar(encode(this.avatarUuid));
        }

        /**
         * 获取对象包含的属性。
         * @returns {Boolean} 是否获取成功。获取成功时，会自动赋值给属性。
         * @example
         * presentation.getProperties();
         */
        getProperties() {
            if (!defined(this.avatarUuid)) {
                console.log("uuid require!");
                return false;
            }
            let pAvatarUuid = Element.prototype.NativeAPI.Uuid_New();
            Element.prototype.NativeAPI.Uuid_SetId(pAvatarUuid, encode(this.avatarUuid));
            let pAvatar = Element.prototype.NativeAPI.MapImpl_getAvatar(pAvatarUuid);
            let avatarPropSize = Element.prototype.NativeAPI.Avatar_GetPropertiesSize(pAvatar);
            for (let i = 0; i < avatarPropSize; ++i) {
                let pProp = Element.prototype.NativeAPI.Avatar_GetProperty(pAvatar, i);
                let name = Element.prototype.NativeAPI.Property_GetName(pProp);
                let value = Element.prototype.NativeAPI.Property_GetValue(pProp);
                if (name == "Visible") {
                    if (value == "true" || value == "1") {
                        this.bVisible = true;
                    } else {
                        this.bVisible = false;
                    }
                } else if (name == "Scale") {
                    this.scale = Vec3Obj.fromStr(value);
                } else if (name == "Rotation") {
                    this.rotation = Vec3Obj.fromStr(value);
                } else if (name == "Translation") {
                    this.translation = Vec3Obj.fromStr(value);
                } else if (name == "Location") {
                    let arr = value.split('/');
                    this.spatialReference = arr[0];
                    this.location = Vec3Obj.fromStr(arr[1]);
                }
            }
            Element.prototype.NativeAPI.Avatar_Delete(pAvatar);
            Element.prototype.NativeAPI.Uuid_Delete(pAvatarUuid);
            return true;
        }
        /**
         * 从场景中销毁自身。
         * @param {CallbackBoolean} [callback=null] 销毁图层后触发的函数回调。
         * @returns null 空值。
         * @example
         * // 销毁图层
         * layer = layer.destroy((state)=>{console.log("destroy status:" + state)});
         */
        destroy(callback) {
            if (!defined(this.avatarUuid)) {
                console.log("avatarUuid is null!");
                return null;
            }
            callbackSystem.register("RemoveAvatar", this.avatarUuid, (state) => {
                if (defined(callback)) {
                    callback(state);
                }
                Element.prototype.Map.presentations = Element.prototype.Map.presentations.filter(item => item !== this);
                callbackSystem.remove("LoadAvatarAndComponent", this.avatarUuid);
                callbackSystem.remove("UpdateAvatarAndComponent", this.avatarUuid);
                callbackSystem.remove("", "PresentationItemEnd");
                callbackSystem.remove("", "LocateAvatar");
                callbackSystem.remove("RemoveAvatar", this.avatarUuid);
                this.avatarUuid = null;
                this.componentUuid = null;
            });
            Element.prototype.NativeAPI.RemoveAvatar(encode(this.avatarUuid));
            return null;
        }
    }
    return Presentation;
});